<template>
    <div>
      <input v-model="amount" placeholder="Monto" type="number">
      <input v-model="description" placeholder="Descripción">
      <button @click="submitPayment">Pagar con PlacetoPay</button>
    </div>
  </template>
  
  <script>
  import api from "@/services/api";
  
  export default {
    data() {
      return {
        amount: 0,
        description: ''
      };
    },
    methods: {
      submitPayment() {
        api.post('/payment', {
          amount: this.amount,
          description: this.description
        }).then(response => {
          window.location.href = response.data.redirectUrl; // Redirige a PlacetoPay
        }).catch(error => {
          console.error('Error al procesar el pago:', error);
        });
      }
    }
  }
  </script>  